import React from 'react';
import { StarIcon, HeadphonesIcon } from 'lucide-react';
export const BookHoverCard = ({
  book,
  darkMode,
  mousePosition
}: {
  book: any;
  darkMode: boolean;
  mousePosition: {
    x: number;
    y: number;
  };
}) => {
  if (!book) return null;
  // Determine position (left or right of cursor)
  const showOnLeft = mousePosition.x > window.innerWidth / 2;
  const cardWidth = 280;
  return <div className={`fixed z-30 w-72 p-4 rounded-lg shadow-md border ${darkMode ? 'bg-gray-800 text-white border-gray-700' : 'bg-white text-gray-900 border-gray-300'}`} style={{
    top: Math.max(mousePosition.y - 100, 20),
    left: showOnLeft ? Math.max(mousePosition.x - cardWidth - 20, 20) : Math.min(mousePosition.x + 20, window.innerWidth - cardWidth - 20)
  }} data-id="element-19490" data-mp="yiz5gvjfton">
      <div className="flex gap-3" data-id="element-19491" data-mp="2cpmmvacpes4y">
        <div className="w-20 h-28 flex-shrink-0 flex flex-col" data-id="element-19492" data-mp="2cqpc7dudomir">
          <div className="w-full h-full rounded bg-center bg-cover" style={{
          backgroundImage: `url(${book.coverImage})`
        }} data-id="element-19493" data-mp="27qjrkhmj00a6" />
          <div className="mt-1 flex items-center justify-center bg-black bg-opacity-70 rounded-full p-1 text-white text-xs" data-id="element-19494" data-mp="1qzelb2mn9jip">
            <StarIcon className="h-3 w-3 text-amber-500 mr-0.5 fill-current" data-id="element-19495" data-mp="1vxptza17dnzc" />
            <span data-id="element-19496" data-mp="20r13xk1bakvh">{book.rating}</span>
          </div>
        </div>
        <div className="flex-1 overflow-hidden" data-id="element-19497" data-mp="25p2lu1n04e5d">
          <h3 className="font-bold text-base mb-1 line-clamp-2" data-id="element-19498" data-mp="25oaskxgvmsi9">
            {book.title}
          </h3>
          {book.series && <p className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-700'} mb-1`} data-id="element-19499" data-mp="2aq04efbxba7e">
              {book.series} #{book.seriesNumber}
            </p>}
          <p className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'} mb-1`} data-id="element-19500" data-mp="2jmr3z1pop76q">
            by {book.writtenAuthor}
          </p>

          <div className="flex flex-wrap gap-1 mt-2" data-id="element-19501" data-mp="pblv9izqq4kj">
            {book.genre && <span className={`text-xs px-2 py-0.5 rounded-full ${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-800'}`} data-id="element-19502" data-mp="1smrlrgp5fnun">
                {book.genre}
              </span>}
            <span className={`text-xs px-2 py-0.5 rounded-full ${darkMode ? 'bg-blue-900 text-blue-100' : 'bg-blue-100 text-blue-800'}`} data-id="element-19503" data-mp="21npu2b6mehj1">
              {book.runtime}
            </span>
          </div>

          <div className="flex items-center mt-2" data-id="element-19504" data-mp="26livkqwzancz">
            <span className={`text-xs flex items-center ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-19505" data-mp="26kpvg8siyw3t">
              <HeadphonesIcon className="h-3 w-3 mr-1" data-id="element-19506" data-mp="2keqn6il27iuo" />
              Audiobook
            </span>
          </div>
        </div>
      </div>
    </div>;
};